import Pane from 'components/Common/Pane'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import LoyaltyAccountLandingPageBenefitItem from './LoyaltyAccountLandingPageBenefitItem'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import BodyText from 'LuxKit/Typography/BodyText'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import Divider from 'LuxKit/Divider'
import { useLocation } from 'react-router'

const Section = styled(Pane)`
  padding: ${rem(24)};
  /* Offset for sticky header */
  scroll-margin-top: 80px;

  ${mediaQueryUp.tablet} {
    padding: ${rem(24)};
  }
`

function LoyaltyAccountLandingPageYourBenefits() {
  const sectionRef = useRef<HTMLDivElement>(null)
  const location = useLocation()
  const account = useAppSelector(state => state.loyalty.account.data)
  const [, tierName] = useCurrentLoyaltyTier()

  useEffect(() => {
    if (location.hash === '#benefits-your-tier' && sectionRef.current) {
      sectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [location.hash])

  return <Section ref={sectionRef} id="benefits-your-tier">
    <VerticalSpacer gap={12}>
      <VerticalSpacer gap={2}>
        <Heading variant="heading3">Your {tierName} <i>benefits</i></Heading>
        {!!account?.statusReviewDate && <BodyText variant="medium">
          Expire <FormatDateTime value={account.statusReviewDate} format="dmy-casual" />
        </BodyText>}
      </VerticalSpacer>
      <VerticalSpacer gap={8}>
        {account?.benefits.map((benefit, index) => <React.Fragment key={benefit.code}>
          {index !== 0 && <Divider kind="secondary" />}
          <LoyaltyAccountLandingPageBenefitItem
            key={benefit.code}
            benefit={benefit}
          />
        </React.Fragment>)}
      </VerticalSpacer>
    </VerticalSpacer>
  </Section>
}

export default LoyaltyAccountLandingPageYourBenefits
